import { render } from "./ProposalPublic.vue?vue&type=template&id=397910be&scoped=true&ts=true"
import script from "./ProposalPublic.vue?vue&type=script&lang=ts"
export * from "./ProposalPublic.vue?vue&type=script&lang=ts"

import "./ProposalPublic.vue?vue&type=style&index=0&id=397910be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397910be"]])

export default __exports__